import React from 'react'
import {DonationInput} from '../../../../donation-input'
import {DonationProps} from './interafces'
import {classes} from './donation.st.css'

export const Donation = ({...props}: DonationProps) => <DonationInput {...props} className={classes.root} />
